import React from "react";
import githubIcon from "../assets/github.svg";
export const GitHubFooter = () => {
  return (
    <div className="fixed bottom-4 right-4 flex items-center space-x-2">
      <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
       ⭐
      </p>
      <a
        href="https://github.com/eleijonmarck/zentered"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={githubIcon} alt="GitHub Repository" className="w-8 h-8" />
      </a>
    </div>
  );
};
